import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t2-logobar" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "head_r" }
const _hoisted_4 = {
  key: 0,
  class: "loginMsg"
}
const _hoisted_5 = ["data"]
const _hoisted_6 = {
  key: 1,
  class: "loginMsg"
}

import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from "vue-router";
import { ElMessage } from 'element-plus';
import { LOGIN_URL } from '@/config/const';

export default /*@__PURE__*/_defineComponent({
  __name: 'loginMessage',
  setup(__props) {

const store = useStore()
const router = useRouter()

const data:any = reactive({
    userInfo:{},
})

const getUserInfo = async() => {
    let res = await store.dispatch('login')
    //#法人类型(C01 企业法人,C02 社团法人,C03 事业单位法人,C04 个体工商户 )
    // let res = {
    //     "userName": "王宝山",
    //     "certNo": "410928196304039633",
    //     "userType": "1",
    //     "userMobile": "17788100338",
    //     "corpType": "C01",
    //     "certificateSno": "91410223MA40GEQL7N",
    //     "corpName": "尉氏县瑞隆置业有限公司",
    // }

    data.userInfo = res;
    console.log('获取登录信息res:::',data.userInfo);
    if (res.code === 200) {
        data.userInfo = res.result
    }
}

const login = () => {
    let finalUrl = window.location.href
    window.sessionStorage.setItem('thisHref',finalUrl);
    console.log('LOGIN_URL',LOGIN_URL + finalUrl)
    window.location.href = LOGIN_URL + finalUrl
}
const userCenter = () => {
    console.log('userCenter登录信息：', data.userInfo);
    router.push('/user-center')
}
const home = () => {
    router.push('/')
}
const logout = () => {
    setTimeout(async()=>{
        data.userInfo = await store.dispatch('logout')
        console.log('login用户信息：', data.userInfo);
        ElMessage.success('退出成功')
        router.push('/')
    },300)
}

let cutDarkValue = ref(store.state.cutDarkValue)
const cutDark = () => {
    cutDarkValue.value === 0?cutDarkValue.value = 1:cutDarkValue.value = 0
    store.commit('setCutDarkValue',cutDarkValue.value)
}
const init = () => {
    getUserInfo()
}
init()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "head_l",
        onClick: home
      }),
      _createElementVNode("div", _hoisted_3, [
        (data.userInfo && data.userInfo.certNo)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createElementVNode("a", {
                class: "top_login",
                data: JSON.stringify(data.userInfo),
                onClick: userCenter
              }, "个人中心", 8, _hoisted_5),
              _cache[0] || (_cache[0] = _createTextVNode(" | ", -1)),
              _createElementVNode("a", {
                class: "top_register",
                onClick: logout
              }, "退出登录")
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createElementVNode("a", {
                class: "top_login",
                onClick: login
              }, "登录"),
              _cache[1] || (_cache[1] = _createTextVNode(" | ", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("a", {
                class: "top_register",
                href: "https://login.hnzwfw.gov.cn/tacs-uc/naturalMan/register?backUrl=https://www.kfzwfw.gov.cn/receiveTicket.jspx",
                target: "_blank"
              }, "注册", -1))
            ])),
        _cache[4] || (_cache[4] = _createElementVNode("a", {
          title: "无障碍通道",
          href: "javascript:",
          class: "top_model",
          target: "_blank",
          onclick: "ShowDetail()",
          accesskey: "g",
          onmousedown: "ShowDetail()"
        }, "无障碍模式", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("a", {
          title: "适老化",
          href: "javascript:",
          class: "top_model",
          target: "_blank",
          onclick: "ShowDetail()",
          accesskey: "g",
          onmousedown: "ShowDetail()"
        }, "适老化", -1)),
        _createElementVNode("a", {
          class: "top_switch",
          onClick: cutDark
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "dayModel" }, "白昼", -1),
          _createElementVNode("span", { class: "darkModel" }, "暗夜", -1)
        ]))])
      ])
    ])
  ]))
}
}

})